export default "__VITE_ASSET__CVO2ZvFY__"